// Same-origin API client for the admin panel.
// Dev: CRA proxy (package.json "proxy") forwards /api -> localhost:8001.
// Prod: Caddy routes /api -> api container.
import axios from "axios";

export const api = axios.create({ baseURL: "/api" });

const TOKEN_KEY = "dd_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/admin/login")) {
      setToken(null);
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export async function loginRequest(username, password) {
  const { data } = await api.post("/admin/login", { username, password });
  setToken(data.token);
  return data;
}

export async function fetchMe() {
  const { data } = await api.get("/admin/me");
  return data;
}

export async function downloadPdf(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}
